import dayjs from "dayjs";

export const soColumns = [
  {
    field: "lineNo",
    headerName: "Line No",
    align: "right",
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    align: "left",
    left: 180,
    width: 200,
  },
  {
    field: "packageID",
    headerName: "Package ID",
    width: 200,
    align: "left",
  },
  {
    field: "packType",
    headerName: "Pack Type",
    width: 120,
    align: "left",
  },
  {
    field: "orderQty",
    headerName: "Order Qty",
    width: 120,
    align: "right",
  },
  {
    field: "orderUOM",
    headerName: "Order UOM",
    width: 120,
    valuesGetter: (col) => {
      return col.label;
    },
    align: "left",
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    width: 120,
    align: "right",
  },
  {
    field: "quantity",
    headerName: "Quantity",
    width: 120,
    align: "right",
  },
  {
    field: "mln",
    headerName: "MLN",
    width: 120,
    align: "right",
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    width: 150,
    align: "right",
    valuesGetter: (col) => {
      return Boolean(col) ? dayjs(col).format("DD/MM/YYYY") : col;
    },
  },
  {
    field: "unitPrice",
    headerName: "Unit Price",
    width: 120,
    align: "right",
  },
  {
    field: "currencyCode",
    headerName: "Currency Code",
    width: 150,
    align: "right",
  },
  {
    field: "discountAmount",
    headerName: "Discount Amount",
    width: 150,
    align: "right",
  },
  {
    field: "taxAmount",
    headerName: "Tax Amount",
    width: 120,
    align: "right",
  },
  {
    field: "orderShelfLife",
    headerName: "Order Shelf Life",
    width: 150,
    align: "right",
  },
];
